import { ServerError } from 'api/errors/serverError'

export type TDraftProcessingErrorReason = 'message_not_a_draft'

export const getErrorReasonFromError = (error: ServerError | null): TDraftProcessingErrorReason | undefined => {
  return error?.response?.data?.message?.reason
}
